/* eslint-disable no-unused-vars */
import dayjs, { Dayjs } from 'dayjs'
import React, { MouseEvent } from 'react'
import { IEvent } from '../../../types'
import CustomTooltip from '../common/CustomTooltip'
import styles from '../SAPPCalendar.module.css'
import MonthlyEvent from './MonthlyEvent'

interface IMonthlyCellProps {
  events: IEvent[]
  date: Dayjs
  currentDate: Dayjs
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onOpenCreate?: (date: Date) => void
  onEventDetail?: (event: IEvent) => void
}

const MonthlyCell = ({
  currentDate,
  events,
  date,
  onOpenDetail,
  onOpenCreate,
  onEventDetail
}: IMonthlyCellProps) => {
  const hasMore = events.length > 2
  const isSameMonth = currentDate.isSame(date, 'month')
  const isToday = dayjs().isSame(date, 'day')

  const handleOpenCreateModal = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return
    onOpenCreate &&
      onOpenCreate(
        dayjs(date).hour(dayjs().hour()).minute(dayjs().minute()).toDate()
      )
  }

  return (
    <div
      className={`${styles['monthly-calendar__cell']} ${
        isToday
          ? styles['monthly-calendar__cell--active']
          : styles['border-gray-4']
      } ${isSameMonth ? styles['bg-white'] : styles['bg-button']}`}
      onClick={handleOpenCreateModal}
    >
      <div
        className={
          isSameMonth ? styles['text-black'] : styles['text-secondary-text']
        }
      >
        {date.format('DD')}
      </div>
      <ul onClick={() => onOpenDetail && onOpenDetail(date.toDate(), events)}>
        {events.slice(0, 2).map((event, index) => (
          <MonthlyEvent
            key={index}
            event={event}
            isSameMonth={isSameMonth}
            onEventDetail={onEventDetail}
          />
        ))}
        {hasMore && (
          <CustomTooltip
            placement='bottom'
            title={
              <div className={styles['calendar-tooltip']}>
                {events.slice(2, events.length).map((event, index) => (
                  <MonthlyEvent
                    key={index}
                    event={event}
                    isSameMonth={isSameMonth}
                    onEventDetail={onEventDetail}
                  />
                ))}
              </div>
            }
          >
            <div
              className={
                isSameMonth
                  ? styles['text-info']
                  : styles['text-secondary-text']
              }
            >
              +{Math.max(events.length - 2, 0)} More
            </div>
          </CustomTooltip>
        )}
      </ul>
    </div>
  )
}

export default MonthlyCell
